const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/

export const isValidGtmId = (gtmId: string | undefined | null): gtmId is string => {
  if (!gtmId) return false
  return GTM_ID_PATTERN.test(gtmId.trim())
}
